import omit from 'lodash-es/omit'

import { buildPagePermalink } from '../../js/utils/urls'
import Article from '../../js/components/page/Article'

function Page(props) {
  const { slugs, data } = props
  const { page } = data

  const { author } = page
  const pageData = omit(page, ['author'])

  const permalink = buildPagePermalink({ slugs })

  return (
    <Article
      permalink={permalink}
      author={author}
      post={pageData}
    />
  )
}

export default Page
